import React from 'react';
import {
  PieChart, Pie, LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, Cell
} from 'recharts';

function ChartsDisplay({ optimalWeightsChartData, performance, COLORS }) {
  if (optimalWeightsChartData.length === 0) return null;

  return (
    <div data-testid="optimal-weights-visualization" className="container" style={{ marginTop: '40px', padding: '20px', backgroundColor: '#323232', borderRadius: '8px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}>
        {/* Bar Chart */}
        <BarChart
          width={300}
          height={300}
          data={optimalWeightsChartData}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <RechartsTooltip />
          <Legend />
          <Bar dataKey="value" fill="#82ca9d" />
        </BarChart>

        {/* Pie Chart */}
        <PieChart width={300} height={300}>
          <Pie
            data={optimalWeightsChartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label
          >
            {optimalWeightsChartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <RechartsTooltip />
        </PieChart>

        {/* Line Chart */}
        {performance.length > 0 && (
          <LineChart
            width={300}
            height={300}
            data={performance}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <RechartsTooltip />
            <Legend />
            <Line type="monotone" dataKey="value" stroke="#8884d8" />
          </LineChart>
        )}
      </div>
    </div>
  );
}

export default ChartsDisplay;
